const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
export {
  transitionalDefaults as default
};
//# sourceMappingURL=axios23.js.map
